export enum PlayerMode {
    MODE_PLAY = 'play',
    MODE_PAUSE = 'pause',
    MODE_STOP = 'stop',
    MODE_REALTIME = 'realtime',
}
